import { useMutation } from '@tanstack/react-query'
import { Toast } from 'ui/components/Toast'
import { CTR } from '~bank-bsa-reporting/service'

import { handlerServerError } from '@orbit/errors'

export const useCTRCancel = (onSuccess: () => void, onError: () => void) =>
  useMutation({
    mutationFn: CTR.cancelCTR,
    onSuccess: async () => {
      Toast.successSmall('The CTR was canceled successfully')
      await onSuccess()
    },
    onError: (error) => {
      onError()
      handlerServerError(error)
    }
  })
